import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getPersonalInfoSuccess,
    getPersonalInfoError,
    getKycBackedError,
    getKycBackedSuccess,
    getPersonalInfoSendDetailsSuccess,
    getPersonalInfoSendDetailsError
} from './personalInfoAction';
import { PERSONAL_INFO_REQ_VALUE, GET_KYC_FROM_BACKEND, GET_CUSTOMER_DETAILS, PERSONAL_INFO_REQUEST_SECOND } from '../actionType';
import { CUSTOMER_DETAILS_LANDING, HANDLE_REFERRAL_URL, PERSONAL_INFO_SEND_DETAILS, PERSONAL_INFO_USER } from '../../../utils/urls';
import { fetchGet, fetchPost } from '../../../utils/request';
import { deleteReferalCode, getStoreReferalCode, setAuthToken } from '../../../utils/localStorage';
import { getCustomerDetailsError, getCustomerDetailsSuccess, referralCodeError, referralCodeSuccess } from '../Auth/Login/actionLogin';
// import { referralMethod } from '../Auth/Login/sagaLogin';

const stateValue = (state: any) => state.personalInfo;
const stateCustValue = (state: any) => state.login;

function* personalInfoReq(): any {
    const stateName = yield select(stateValue);
    try {
        const body = {
            first_name: stateName?.personalInputValue?.firstName,
            last_name: stateName?.personalInputValue?.lastName,
            father_name: stateName?.personalInputValue?.father_name,
            pan_number: (stateName?.personalInputValue?.panNumber).toUpperCase(),
            email: stateName?.personalInputValue?.email,
            dob: stateName?.personalInputValue?.dob,
            gender: stateName?.personalInputValue?.gender === "Male" ? 'M' : stateName?.personalInputValue?.gender === "Female" ? 'F' : '',
            address_line_1: stateName?.personalInfoSecondInput?.address,
            pincode: parseInt(stateName?.personalInfoSecondInput?.pincode),
            aadhaar_number: stateName?.personalInputValue?.adharnumber,
            referred_by:getStoreReferalCode() ? getStoreReferalCode() : ''
        }
        const response = yield call(fetchPost, PERSONAL_INFO_USER, body);
        if (response?.status) {
            if (response?.results?.client_token) {
                yield setAuthToken(response?.results?.client_token);
                yield put(getPersonalInfoSuccess(response));
                return true;
            }
            if (getStoreReferalCode() !== "null" && getStoreReferalCode() !== null)
                yield referralMethod();
            else deleteReferalCode();

        }
        if (response.error) {
            if (response?.error?.errors?.dob) {
                yield put(getPersonalInfoError(response?.error?.errors?.dob));
            } else {
                yield put(getPersonalInfoError(response?.error?.errors));
            }
            return false;
        }

    } catch (error) {
        yield put(getPersonalInfoError("Internal Server Error"))
    }
}

function* personalInfoData(): any { // Had to store data for backend
    const stateName = yield select(stateValue);
    try {
        const body = {
            first_name: stateName?.personalInputValue?.firstName,
            last_name: stateName?.personalInputValue?.lastName,
            father_name: stateName?.personalInputValue?.father_name,
            pan_number: (stateName?.personalInputValue?.panNumber).toUpperCase(),
            email: stateName?.personalInputValue?.email,
            dob: stateName?.personalInputValue?.dob,
            aadhaar_number: stateName?.personalInputValue?.adharnumber,
            gender: stateName?.personalInputValue?.gender === "Male" ? 'M' : stateName?.personalInputValue?.gender === "Female" ? 'F' : '',
            referred_by:getStoreReferalCode() ? getStoreReferalCode() : ''
        }
        const response = yield call(fetchPost, PERSONAL_INFO_SEND_DETAILS, body);
        if (response?.status) {
            yield put(getPersonalInfoSendDetailsSuccess(response));
        }
        if (response?.error) {
        yield put(getPersonalInfoSendDetailsError(JSON.stringify(response.error?.errors)));
        }
        
    } catch (error) {
        yield put(getPersonalInfoSendDetailsError(JSON.stringify(error)));
    }
}

function* kycFromBackend(): any {
    try {
        const response: any = {
            status: true, result: { url: 'https://www.google.com/' }
        }
        if (response.error) {
            yield put(getKycBackedError(response));
            return false;
        }
        if (response.status) {
            yield put(getKycBackedSuccess(response));
            return true;
        }
    } catch (error) {
        yield put(getKycBackedError(error))
    }
}
function* referralMethod(): any {
    let body = {
        referral_code: getStoreReferalCode(),
    };
    try {
        const response = yield call(fetchPost, HANDLE_REFERRAL_URL, body);
        deleteReferalCode();
        return yield put(referralCodeSuccess(response.status));
    } catch (error) {
        yield put(referralCodeError(error));
    }
}

function* fetchCustomerDetails(): any {
    const stateCust = yield select(stateCustValue);
    try {
        const response = yield call(fetchGet, CUSTOMER_DETAILS_LANDING + stateCust.pageNumber);
        if (response.error) {
            yield put(getCustomerDetailsError(response.error));
            return false;
        }
        if (response.status) {
            yield put(getCustomerDetailsSuccess(response));
            return true;
        }
    } catch (error) {
        yield put(getCustomerDetailsError(error))
    }
}

export default function* sagaPersonalInfo() {
    yield all([
        takeLatest(PERSONAL_INFO_REQUEST_SECOND, personalInfoReq),
        takeLatest(GET_KYC_FROM_BACKEND, kycFromBackend),
        takeLatest(GET_CUSTOMER_DETAILS, fetchCustomerDetails),
        takeLatest(PERSONAL_INFO_REQ_VALUE, personalInfoData)
    ])
}